<template>
    <modal v-on:closemodal="close" @close="close" dialog="modal-m" class="dark-top" :footer="true">
        <div slot="title">
            <h2>Send a test email</h2>
        </div>
        <div slot="body">
            <div class="form-group d-flex">
                <div class="col-sm-12 pt-3">
                    <label class="mb-1">Send a test to:</label>
                    <div class="input-min-height mb-2">
                        <div class="col-sm-8 p-0" :class="{ error: $v.sendTo.$error }">
                            <label class="full" :class="{ error: $v.sendTo.$error }">
                                <input
                                    type="text"
                                    class="bg-lighter"
                                    v-model="sendTo"
                                    @input="$v.sendTo.$touch"
                                    placeholder="email1@domain.com"
                                />
                            </label>
                            <div v-if="$v.sendTo.$invalid" class="messages error">
                                <span v-if="!$v.sendTo.isEmailValid && $v.sendTo.required">Invalid email</span>
                                <span v-if="!$v.sendTo.required">Email is required</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <label class="mb-2">Select email test type:</label>
                        <div class="mb-3 ml-4 fs-small">
                            <div class="d-flex">
                                <radio v-model="emailType" value="PreEvent" class="darkest">Reminder email</radio >
                            </div>
                            <div class="d-flex mt-2">
                                <radio v-model="emailType" value="PostEvent" class="darkest">Follow-Up Email</radio >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-end">
            <button type="button" class="btn cancel wider mr-3" @click="close">Cancel</button>
            <button type="button" class="btn wider mr-3" @click="sendEmail" :disabled="$v.sendTo.$invalid" :class="{'tertiary': sendingEmail}">
                <span v-if="!sendingEmail">Send Email</span>
                <loader v-else></loader>
            </button>
        </div>
    </modal>
</template>

<script>
    import Modal from './Modal';
    import { required } from "vuelidate/lib/validators";
    import { mapActions } from 'vuex';
    import Loader from '@/tools/loaders/loader1';

    export default {
        data: function() {
            return {
                sendTo: null,
                emailType: 'PreEvent',
                culture: 'EN',
                sendingEmail: false,
            }
        },
        validations: {
            sendTo: {
                required,
                isEmailValid: function (val) {
                    return this.emailValidation(val);
                },
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'testEmail'
            ]),
            emailValidation(val) {
                if (!val) {
                    return false;
                }

                let separator = null;
                
                if (val.includes(",")) {
                    separator = ",";
                } else if (val.includes(";")) {
                    separator = ";";
                }

                let emailArray = separator ? val.split(separator) : [val];

                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

                return emailArray.every(email => emailRegex.test(email.trim()));
            },
            sendEmail: function() {
                const payload = {
                    "Culture": this.culture,
                    "SendTo": this.sendTo,
                    "EmailType": this.emailType,
                }
                
                this.$toasted.info(`Sending to ${this.sendTo}`);
                this.sendingEmail = true;
                
                this.testEmail(payload).then((success)=> {
                    if (success) {
                        this.$toasted.success(`Sent`);
                        this.sendingEmail = false;
                        this.closeModal();
                    }
                }).catch(() => {
                    this.$toasted.error(`Something went wrong. Please try again!`);
                    this.sendingEmail = false;
                    this.closeModal();
                });
            },
            close: function() {
                this.closeModal();
            },
        },
        components: {
            Modal,
            Loader
        }
    }
</script>

<style lang="scss" scoped>
    .input-min-height {
        min-height: 65px;
    }
</style>



// WEBPACK FOOTER //
// SendTestEmail.vue?5e6e856a